import { cn } from '@/lib/utils'
import { BodyText, HeadlineText } from 'design-configuration/components'

export function OnboardingStepHeader({
  title,
  subtitle,
  className
}: {
  title: string
  subtitle?: string
  className?: string
}): React.ReactNode {
  return (
    <div className={cn('px-md gap-sm flex flex-col', className)}>
      <HeadlineText className="font-medium">{title}</HeadlineText>
      {subtitle ? <BodyText>{subtitle}</BodyText> : null}
    </div>
  )
}
